"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWorldLogoutUI = void 0;
const createImage_1 = require("../components/createImage");
const createPanel_1 = require("../components/createPanel");
const pixel_pigeon_1 = require("pixel-pigeon");
const isWorldCombatInProgress_1 = require("../../isWorldCombatInProgress");
const state_1 = require("../../../state");
const createWorldLogoutUI = () => {
    const condition = () => state_1.state.values.worldState !== null && (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false;
    (0, createPanel_1.createPanel)({
        condition,
        height: 24,
        imagePath: "panels/basic",
        width: 48,
        x: 256,
        y: 0,
    });
    (0, createImage_1.createImage)({
        condition,
        height: 14,
        imagePath: "arrows/logout",
        onClick: () => {
            (0, pixel_pigeon_1.emitToSocketioServer)({
                data: {},
                event: "world/exit-to-main-menu",
            });
        },
        width: 28,
        x: 266,
        y: 5,
    });
};
exports.createWorldLogoutUI = createWorldLogoutUI;
